import { Trans } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import { useDeleteIntegration } from 'src/api/queries';
import { Button, Modal } from 'src/components';

export const RemoveIntegrationModal = ({
  integrationId,
  integrationName,
}: {
  integrationId: string;
  integrationName: string;
}) => {
  const deleteIntegration = useDeleteIntegration();

  return (
    <Modal.Content>
      <div className="flex flex-col items-center">
        <Typography variant="heading-sm">
          <Trans context="remove-integration-modal">Remove integration</Trans>
        </Typography>

        <Typography variant="body-md">
          <Trans context="remove-integration-modal">
            Are you sure you want to remove the integration &quot;
            {integrationName}&quot;?
          </Trans>
        </Typography>

        <div className="mt-32 flex justify-center gap-16">
          <Button
            data-cy="remove-integration-modal-confirm"
            onClick={() => deleteIntegration.mutate(integrationId)}
            loading={deleteIntegration.isPending}
          >
            <Trans context="remove-integration-modal">Yes, remove</Trans>
          </Button>

          <Modal.Close asChild>
            <Button variant="secondary">
              <Trans context="remove-integration-modal">No, cancel</Trans>
            </Button>
          </Modal.Close>
        </div>
      </div>
    </Modal.Content>
  );
};
